import { render, staticRenderFns } from "./AppTeamRearrange.vue?vue&type=template&id=61597002"
import script from "./AppTeamRearrange.vue?vue&type=script&lang=js"
export * from "./AppTeamRearrange.vue?vue&type=script&lang=js"
import style0 from "./AppTeamRearrange.vue?vue&type=style&index=0&id=61597002&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports